const SPH_SOURCE_LOCATION = 'signed_petition_home';

export function isSphChipInOrigin(sourceLocation: string | undefined): boolean {
	return sourceLocation === SPH_SOURCE_LOCATION;
}

export function sphPetitionHomePath(slug: string): string {
	return `/p/${encodeURIComponent(slug)}/signed-petition-home`;
}

export function withSphChipInOrigin(url: string, sourceLocation: string | undefined): string {
	if (!isSphChipInOrigin(sourceLocation)) return url;

	return `${url}${url.includes('?') ? '&' : '?'}source_location=${SPH_SOURCE_LOCATION}`;
}
